import React from "react";
import { Card } from "react-bootstrap";

function Objective() {
  return (
    <Card
      className="wrapper_card my-3 p-0 objective-bg shadow"
      style={{ borderRadius: 1 + "rem" }}
    ></Card>
  );
}

export default Objective;
